import React, {useState, useRef, useEffect} from 'react';
import Drawer from '@mui/material/Drawer';

import ExerciseAppBar from '../../components/ExerciseAppBar';
import ProductsOverlay from './ProductsOverlay';
import Board from './Board';
import SecondaryAppBar from '../../components/SecondaryAppBar';
import Card from '../../components/Card';
// import FlamingoLiteracyLogoDark from '../../components/icons/FlamingoLiteracyLogoDark';

import pens from '../data/pens';

import '../css/fonts.css';

const DEFAULT_PEN = 'penOrangeThick';

export default function WordDivisionApp({exercise, mode}) {
  const [isDrawerOpen, setDrawerOpenState] = useState(false);
  const [isCardVisible, setCardVisibleState] = useState(false);
  const [wordsIndex, setWordsIndex] = useState(0);
  const [pen, setPen] = useState(pens[DEFAULT_PEN]);

  const canvasRef = useRef(null);

  useEffect(() => {
    handleReset();
  }, [exercise._id]); // eslint-disable-line react-hooks/exhaustive-deps

  // Floating Action Button
  function handleClickFAB() {
    setDrawerOpenState(!isDrawerOpen);
  }

  function handleClickCloseDrawer() {
    setDrawerOpenState(false);
  }

  function handleClickSelectItem(id, model) {
    setPen(model);
    setDrawerOpenState(false);
  }

  function handleClickUndo() {
    canvasRef?.current?.undo();
  }

  function handlePreviousWord() {
    setWordsIndex((previousWordsIndex) => Math.max(previousWordsIndex - 1, 0));
    clearDrawings();
  }
  function handleNextWord() {
    setWordsIndex((previousWordsIndex) => Math.min(previousWordsIndex + 1, exercise.config.words.length - 1));
    clearDrawings();
  }

  // Trashcan
  function handleClearDrawings() {
    clearDrawings();
  }

  // Reset - clear drawings and reset to first word
  function handleReset() {
    setWordsIndex(0);
    setCardVisibleState(false);
    clearDrawings();
  }

  function handleClickCard() {
    setCardVisibleState(!isCardVisible);
  }

  function clearDrawings() {
    canvasRef?.current?.resetCanvas();
  }

  return (
    <>
      {mode === 'EXERCISE' && <ExerciseAppBar exercise={exercise} />}

      <SecondaryAppBar
        onClickUndo={handleClickUndo}
        onClickPrevious={handlePreviousWord}
        onClickNext={handleNextWord}
        onClickReset={handleReset}
        onClickClear={handleClearDrawings}
        onClickFAB={handleClickFAB}
        iconFABType="EDIT"
        onClickCard={handleClickCard}
      />

      {/* <div className="screen-width-warning-cover">
        <FlamingoLiteracyLogoDark style={{width: 250, height: 91}} />
        <h4 className="message title">This screen is too small!</h4>
        <h5 className="message subtitle">Please grab a tablet or something larger.</h5>
      </div> */}

      <Board word={exercise.config.words[wordsIndex]} canvasRef={canvasRef} pen={pen} />

      {isCardVisible && <Card onClose={handleClickCard} />}

      <Drawer anchor="right" variant="persistent" open={isDrawerOpen} onClose={handleClickCloseDrawer}>
        <ProductsOverlay onClickActionBtn={handleClickSelectItem} onClickClose={handleClickCloseDrawer} pen={pen} />
      </Drawer>
    </>
  );
}
